angular.module('FmsApp').factory("MyPlantingSeasonListFactory", ["$resource", function ($resource) {
    return $resource('/api/v1.0/khutils/plantingseasons/?as_dict=yes');
}]);